import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { AzureMySqlSink } from 'app/model/pipeline/copysink/azure-mysql.copysink';
import { TabularSinkAdapter } from './tabular.sink.adapter';
import { CopySinkAdapter } from 'app/model/adapters/activities/copysink/copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureMySqlSink),
    asynchronous: true,
    adapts: {
        type: '*',
        writeBatchTimeout: '*',
        writeBatchSize: '*',
        preCopyScript: '*'
    }
})
export class AzureMySqlSinkAdapter extends CopySinkAdapter<AzureMySqlSink, Model.AzureMySqlSink> {
    protected override async _toResource(model: AzureMySqlSink): Promise<Model.AzureMySqlSink> {
        const result: Model.AzureMySqlSink = {
            type: 'AzureMySqlSink'
        };
        TabularSinkAdapter.toSinkResource(model, result);
        return result;
    }

    protected override async _toModel(resource: Model.AzureMySqlSink, owner: Activity): Promise<AzureMySqlSink> {
        const result = Owned.create<AzureMySqlSink>(Metamodel.modelFor(AzureMySqlSink), owner);
        TabularSinkAdapter.toSinkModel(resource, result);
        return result;
    }
}
